import { render, staticRenderFns } from "./Regalos.vue?vue&type=template&id=160e3195"
import script from "./Regalos.vue?vue&type=script&lang=js"
export * from "./Regalos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports